import { Injectable } from '@angular/core';
import { GatewayTimeoutHandler } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class RrsGatewayTimeoutHandler extends GatewayTimeoutHandler {
  override handleError(): void {}
}
